(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 4526:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(710);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ participants; }
/* harmony export */ });
var knut = {
    twitchId: 43494917,
    name: "Knut",
    url: "https://www.twitch.tv/knut",
    twitchName: "knut"
};
var wakewilder = {
    twitchId: 526832402,
    name: "WakeWilder",
    url: "https://www.twitch.tv/wakewilder",
    twitchName: "wakewilder"
};
var participants = [
    {
        category: "trainers",
        members: [
            knut,
            wakewilder
        ]
    },
    {
        category: "streamers",
        members: [
            {
                twitchId: 94753024,
                name: "Mizkif",
                url: "https://www.twitch.tv/mizkif",
                twitchName: "mizkif"
            },
            {
                twitchId: 21841789,
                name: "Nmplol",
                url: "https://www.twitch.tv/Nmplol",
                twitchName: "nmplol"
            },
            {
                twitchId: 37522866,
                name: "Cyr",
                url: "https://twitch.tv/cyr",
                twitchName: "cyr"
            },
            {
                twitchId: 127463427,
                name: "RichWCampbell",
                url: "https://www.twitch.tv/richwcampbell",
                twitchName: "richwcampbell"
            },
            {
                twitchId: 27717340,
                name: "Tectone",
                url: "https://www.twitch.tv/tectone",
                twitchName: "tectone"
            },
            {
                twitchId: 96858382,
                name: "Erobb221",
                url: "https://www.twitch.tv/erobb221",
                twitchName: "erobb221"
            },
            {
                twitchId: 38746172,
                name: "EsfandTV",
                url: "https://www.twitch.tv/esfandtv",
                twitchName: "esfandtv"
            },
            {
                twitchId: 29400754,
                name: "Lacari",
                url: "https://www.twitch.tv/Lacari",
                twitchName: "lacari"
            }, 
        ]
    },
    {
        category: "chefs",
        members: [
            {
                twitchId: 68090599,
                name: "Exxzy",
                url: "https://www.twitch.tv/exxzy",
                twitchName: "exxzy"
            }, 
        ]
    },
    {
        category: "guests",
        members: [
            {
                twitchId: 26194208,
                name: "MitchJones",
                url: "https://www.twitch.tv/mitchjones",
                twitchName: "mitchjones"
            },
            {
                twitchId: 32491081,
                name: "Malena",
                url: "https://www.twitch.tv/malena",
                twitchName: "malena"
            },
            {
                twitchId: 192133946,
                name: "Jeanette",
                url: "https://www.twitch.tv/jeanetteiswatching",
                twitchName: "jeanetteiswatching"
            },
            {
                twitchId: 503310135,
                name: "HafthorJulius",
                url: "https://www.twitch.tv/hafthorjulius",
                twitchName: "hafthorjulius"
            },
            {
                twitchId: 31069476,
                name: "dCapio",
                url: "https://www.twitch.tv/dcapio",
                twitchName: "dcapio"
            }, 
        ]
    },
    {
        category: "judges",
        members: [
            knut,
            wakewilder,
            {
                twitchId: 32491081,
                name: "Malena",
                url: "https://www.twitch.tv/malena",
                twitchName: "malena"
            },
            {
                twitchId: 26261471,
                name: "Asmongold",
                url: "https://www.twitch.tv/asmongold",
                twitchName: "asmongold"
            }, 
        ]
    }, 
];


/***/ }),

/***/ 710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/image.js
var next_image = __webpack_require__(7659);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/layout/PageLayout.tsx + 4 modules
var PageLayout = __webpack_require__(2582);
// EXTERNAL MODULE: ./content/text.ts
var content_text = __webpack_require__(9862);
;// CONCATENATED MODULE: ./components/mainPage/Introduction.tsx


function Introduction() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "my-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroductionSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-2xl font-bold text-knut-light-header dark:text-knut-dark-header",
                            children: "What is Camp Knut?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: content_text/* introduction.whatIs */.eF.whatIs
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroductionSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-2xl mt-8 font-bold text-knut-light-header dark:text-knut-dark-header",
                            children: "Goal \uD83C\uDFC6"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: content_text/* introduction.goal */.eF.goal
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroductionSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-2xl mt-8 font-bold text-knut-light-header dark:text-knut-dark-header",
                            children: "Who is Knut?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: content_text/* introduction.whoIsKnut */.eF.whoIsKnut
                        })
                    ]
                })
            ]
        })
    });
};
var IntroductionSection = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "my-10",
        children: children
    });
};

// EXTERNAL MODULE: ./components/ui/CustomLink.tsx
var CustomLink = __webpack_require__(5115);
// EXTERNAL MODULE: ./content/streamers.ts
var streamers = __webpack_require__(1167);
;// CONCATENATED MODULE: ./components/mainPage/Participants.tsx



function Participants(param) {
    var twitchData = param.twitchData;
    var ref, ref1, ref2, ref3, ref4;
    var categories = [
        {
            title: "Trainers",
            data: (ref = streamers/* participants.find */.U.find(function(e) {
                return e.category === "trainers";
            })) === null || ref === void 0 ? void 0 : ref.members
        },
        {
            title: "Judges",
            data: (ref1 = streamers/* participants.find */.U.find(function(e) {
                return e.category === "judges";
            })) === null || ref1 === void 0 ? void 0 : ref1.members
        },
        {
            title: "Streamers",
            data: (ref2 = streamers/* participants.find */.U.find(function(e) {
                return e.category === "streamers";
            })) === null || ref2 === void 0 ? void 0 : ref2.members
        },
        {
            title: "Guests",
            data: (ref3 = streamers/* participants.find */.U.find(function(e) {
                return e.category === "guests";
            })) === null || ref3 === void 0 ? void 0 : ref3.members
        },
        {
            title: "Chefs",
            data: (ref4 = streamers/* participants.find */.U.find(function(e) {
                return e.category === "chefs";
            })) === null || ref4 === void 0 ? void 0 : ref4.members
        }, 
    ];
    var isLive = function(user_login) {
        var ref;
        return ((ref = twitchData.find(function(s) {
            return s.user_login === user_login;
        })) === null || ref === void 0 ? void 0 : ref.type) === "live" || false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "my-10 grid w-full grid-cols-2 gap-4 md:grid-cols-5",
        children: categories.map(function(category) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-2xl mt-4 text-left font-black text-knut-light-header dark:text-knut-dark-header",
                        children: category.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex flex-col items-start text-left",
                        children: category === null || category === void 0 ? void 0 : (ref = category.data) === null || ref === void 0 ? void 0 : ref.map(function(e) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                        href: e.url,
                                        type: "a",
                                        children: e.name
                                    }),
                                    isLive(e === null || e === void 0 ? void 0 : e.twitchName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "absolute ml-1.5 inline-block h-3 w-3 shrink-0 pt-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "absolute inline-flex h-3 w-3 animate-ping rounded-full bg-red-600 opacity-75"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "absolute inline-flex h-3 w-3 rounded-full bg-red-600"
                                            })
                                        ]
                                    })
                                ]
                            }, e.name);
                        })
                    })
                ]
            }, category.title);
        })
    });
};

// EXTERNAL MODULE: ./components/ui/Important.tsx
var Important = __webpack_require__(9001);
// EXTERNAL MODULE: ./content/links.ts
var links = __webpack_require__(2304);
;// CONCATENATED MODULE: ./pages/index.tsx









var Home = function(param) {
    var twitch = param.twitch;
    var og_image = {
        url: "/CampKnutMerch.webp"
    };
    var og = {
        site_name: content_text/* introduction.title */.eF.title,
        title: content_text/* introduction.title */.eF.title,
        locale: "en_GB",
        image: og_image,
        description: content_text/* seo.description */.$K.description,
        type: "website",
        url: links/* baseUrl */.FH
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        openGraph: og,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/CampKnutMerch.webp",
                        alt: "Camp Knut",
                        width: 2560,
                        height: 1450,
                        priority: true,
                        decoding: "async",
                        className: "aspect-auto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Introduction, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Participants, {
                        twitchData: twitch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Important/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "\uD83D\uDCA1 ",
                                content_text/* tips.knowYourLimits */.q4.knowYourLimits
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Important/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "\uD83D\uDCA1 ",
                                content_text/* tips.supplements */.q4.supplements
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl mt-4 font-black text-knut-light-header dark:text-knut-dark-header",
                                        children: "\uD83E\uDD69 Meal Plans"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "https://docs.google.com/spreadsheets/d/1Fto6sArnx-lBoxXyFEC3cLCbVQkJdwT9-JsPD9Agra8/edit?usp=sharing",
                                            type: "a",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "OTK Meal plans"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "https://bit.ly/3vil5en",
                                            type: "a",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "Mizkif meal plan with supplements"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "https://bit.ly/3cReLVb",
                                            type: "a",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "Mizkif meal plan without eggs and supplements"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl mt-4 font-black text-knut-light-header dark:text-knut-dark-header",
                                        children: "\uD83D\uDC96 Community"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "/workout/camp-knut-amazon-supplements-by-wakewilder",
                                            type: "Link",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    " ",
                                                    "Amazon Supplements by ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "WakeWilder"
                                                    }),
                                                    " "
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "/workout/stream-workout-log-maintained-by-drstone",
                                            type: "Link",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    " ",
                                                    "Stream workout log - Maintained by ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "DrStone"
                                                    }),
                                                    " "
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "\uD83D\uDCC0",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                href: "https://open.spotify.com/playlist/0bNUdcAFj5Un6XNKZ5Xora?si=e5e3832466244996",
                                                type: "a",
                                                darkColor: "dark:text-knut-dark-header",
                                                lightColor: "text-knut-light-header",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        " ",
                                                        "Camp Knut Gym Playlist - Maintained by ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Tahtooz"
                                                        }),
                                                        " "
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl mt-4 mb-2 font-black text-knut-light-header dark:text-knut-dark-header",
                                        children: "\uD83D\uDCD5 Plans"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "/workout/workout-beginner",
                                            type: "Link",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "Workout Beginner"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "/workout/workout-plan-week-1",
                                            type: "Link",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "Workout plan Week 1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "/workout/workout-plan-week-2",
                                            type: "Link",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "Workout plan Week 2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "/exercises",
                                            type: "Link",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "Exercises"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl mt-4 mb-2 font-black text-knut-light-header dark:text-knut-dark-header",
                                        children: "\uD83D\uDEE0️ Tools"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-knut-light-header dark:text-knut-dark-header",
                                        children: [
                                            "MyFitnessPal",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                href: "https://apps.apple.com/us/app/myfitnesspal-calorie-counter/id341232718",
                                                type: "a",
                                                darkColor: "dark:text-knut-dark-header",
                                                lightColor: "text-knut-light-header",
                                                children: "iOS"
                                            }),
                                            " ",
                                            "/",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                href: "https://play.google.com/store/apps/details?id=com.myfitnesspal.android&amp;hl=en&amp;gl=US",
                                                type: "a",
                                                darkColor: "dark:text-knut-dark-header",
                                                lightColor: "text-knut-light-header",
                                                children: "Android"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "https://www.bodybuilding.com/fun/bmr_calculator.htm",
                                            type: "a",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "BMR Calculator"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl mt-4 mb-2 font-black text-knut-light-header dark:text-knut-dark-header",
                                        children: "\uD83D\uDCC8 Progress"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "",
                                            type: "Link",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "Camp Knut - Calendar"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "/workout/weekly-results",
                                            type: "Link",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "Weekly results"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl mt-4 mb-2 font-black text-knut-light-header dark:text-knut-dark-header",
                                        children: "\uD83D\uDCC3 Articles"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: "https://physiqonomics.com/fat-loss/",
                                            type: "a",
                                            darkColor: "dark:text-knut-dark-header",
                                            lightColor: "text-knut-light-header",
                                            children: "The Best Fat Loss Article on the Motherfuckin’ Internet"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-20 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-xl mt-4 font-black text-knut-light-header dark:text-knut-dark-header",
                                children: "Want to help out?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    href: "https://github.com/Bitsnoxx/CampKnut/issues",
                                    type: "a",
                                    lightColor: "text-knut-light-header",
                                    darkColor: "dark:text-knut-dark-header",
                                    children: "Roadmap"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Important/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    "If you have questions about training - Post them in #camp-knut in the",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                        href: "http://discord.gg/knut",
                                        type: "a",
                                        darkColor: "dark:text-knut-dark-header",
                                        lightColor: "text-knut-light-header",
                                        children: "discord"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    "Feedback, issues or questions? Contact ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Bitsnoxx#1337"
                                    }),
                                    " on Discord."
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [154,555,131,774,888,179], function() { return __webpack_exec__(4526); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);